import React from 'react'
import './blogs.css'
const Neha_Aggarwal = () => {
    return (
        <div className='blog'>
            <div className='container-fluid'>
                <div className='row blog-row'>
                    <div className='col-md-4'>
                        <img src='placement-postulates/dp/Neha.jpg' className='blog-dp' alt='neha'></img>
                    </div>
                    <div className='col-md-8'>
                        <div className='blog-head'>
                            <h2>Neha Aggarwal</h2>
                            <small>Product Engineer at Zomato</small>
                        </div>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className='row'>
                        <div>
                        <p>Hi Everyone!</p>
            <p>I am Neha Aggarwal, a final year undergraduate majoring in Civil Engineering and hoping to complete my
                minors in IME. I will be joining Zomato as a Product Engineer (SDE 1). In my 3rd year of summer, I did a
                Data Science internship in Mobileum Inc, which was not from the campus internship season. I have done
                a few projects under the guidance of professors in my 2nd year summers and a few course projects also.
                All these things made up the technical section of my resume during placements. Talking about
                extracurriculars, I was pretty weak at them. I tried many things (mainly Hindi Sahitya Sabha, Athletics,
                Aeromodelling club, Aerial Robotics, etc.), but the only place I loved working was the Students'
                Placement Office. I was Assistant coordinator there in my 3rd year and company coordinator in my 2nd
                year. I wanted to become an overall placement coordinator as well, but I didn't apply for it because, at
                that time, I solely wanted to focus on my placements. All the SPO people are quite close to my heart,
                and I really enjoyed working there.

            </p>
            <p> <img class="blog-image-left" src="placement-postulates/blogs/Neha-Aggarwal/1.jpg"/>
                If I talk about my internship season. I had a good resume at that time. I also had a good CPI. But my
                pain point was coding. I just practiced a little and focused more on building my resume, which didn't
                work. I realized how much I lagged behind in terms of coding skills. As a result, I did not get an
                internship through the campus internship season. Many of you who didn't get a campus internship would be
                disheartened, just like I was at that time. But I think that motivated me to prepare even better for the
                placements in my case. I had a fear in my mind that what if I would have to face a similar situation
                during my placements. That fear made me push my limits more. I recommend you guys do the same thing and
                try to enhance your skills rather than just getting worried.
                <br/><br/>
                During internships, I also realized that the role of a resume is mainly during the interviews. Most of
                the companies had a CPI cutoff which was not an issue in my case. I was above that cutoff in most of the
                cases. So the main thing for me is clearing the tests. And one more thing which I noticed is if you get
                enough shortlists for interviews, you will surely clear one. People learn from their mistakes in an
                interview, and when they give a few, they become comfortable with the things.

            </p> 
            <p> <img class="blog-image-right" src="placement-postulates/blogs/Neha-Aggarwal/2.jpg"/>
                I started my placement preparation after mid sems of my 6th semester (around the last week of March).
                Yeah, I know it's quite early, according to some people, but it will be good for you if you start as
                early as possible. In my case, I never thought ki jaldi chalu kar k koi fayada nahi hua. It was
                beneficial for me. I had taken a course at demux academy. I started by watching their videos and solving
                questions on Interviewbit. I was going slow, but I was doing it consistently. I solved 2-3 questions a
                day on a regular basis for a couple of months. I covered almost all the topics. In the end, I completed
                almost 75-80% of the questions on interviewbit.

                <br/><br/>
                I also prepared for aptitude (quant, LR and DI). I solved a few CAT practice papers. I also did a gfg
                course that had coding and aptitude tests. I watched video lectures of TIME for DI and LR and solved
                their few worksheets. I had also taken a course on prepleaf. I also gave practice tests on Pariksha and
                My Analytics School placement test series. All this helped me improve my aptitude speed. One can also
                skip the aptitude preparation if you are solely sitting for software profiles or if you have a quite
                good speed in doing aptitude. I had an average speed, and I knew that most of the people on our campus
                would be having that. So, I did prepare for aptitude as well.

            </p>
            <p> <img class="blog-image-left" src="placement-postulates/blogs/Neha-Aggarwal/3.jpg"/>
                For puzzles, I did brainstellar twice and all the gfg puzzles twice. I did a few interviewbit puzzles
                also. I also started with the "50 Challenging Problems in Probability" book, but I could not finish it.
                Puzzles are very important from an interview perspective for almost all the profiles. Please do not
                leave them.
                <br/><br/>

                Initially, I was aiming for software and analytics-type roles. So I didn't prepare for case studies a
                lot. I just did basic preparation for them with a senior and a few of my batchmates. I did not prepare
                for SQL, which was asked in a few analytics-type roles. I would recommend you to learn SQL if you are
                sitting for analytics roles. I wanted to learn it, but I did not get enough time for it.

            </p> 
            <p>Now talking about the resume, my story doesn't differ from others. The template for the resume is almost
                similar to most people in the college, so I asked for a template from a batchmate and edited it. Then
                started the reviewing process. Reviewing the resume is the most important part, every batchmate and
                senior pointed out some mistakes that helped me come out with the final draft. This is a cumbersome and
                time-consuming task but parallelly very important also. I prepared 2-3 resumes for different profiles
                with minor changes but ended up using only 1 for every profile. You can connect with me in case you need
                my resume for reference.


            </p>
            <p> <img class="blog-image-right" src="placement-postulates/blogs/Neha-Aggarwal/4.jpg"/>
                Our placement tests started around the end of September. My tests were going well, but I always had
                anxiety in my mind about whether I would be shortlisted or not. I applied for almost all the profiles
                other than core roles and PM (because they usually have deck submissions, and I didn't have time for
                that). Also, I never prepared for PM roles. For consulting, I was more like ki mera shortlist to nahi
                hoga par apply krne me bhi kya jaata. But the results were surprising; I was shortlisted for two
                consulting firms in 1.1 (Arthur D Little, Alvarez and Marsal) and 2 in 2.1 (Accenture Solutions and
                Praxis).
                <br/><br/>
                
                So I started preparing for the consulting profile as well. I did cases in a group of 3-4. I asked a few
                of my friends who were already placed in consulting firms to help me with the cases. Please do not read
                the cases. Practice them!! I also did 2 to 3 practice sessions with my buddies provided by the companies
                I was shortlisted in. But ye saari preparation utna kaam nahi aayi mujhe. I guess there were quite
                better people available for the consulting firms in 1.1, and I did not reach 2.1 to give their
                interviews. But surely, if I wouldn't make it in 1.2, I would have needed that preparation.

               

            </p>
            <p> <img class="blog-image-left" src="placement-postulates/blogs/Neha-Aggarwal/5.jpg"/>
                And yes, CPI plays a very important role in placements. Not just for giving the tests but in some cases,
                interview shortlists were also based on a combination of CPI and test results. In internships, it
                doesn't have that much impact, but in placement, you will clearly see that impact. I was luckily above
                that bar where I could have been rejected based on CPI by not all but most of the firms.
                In my case, I was never a lot worried about the shortlist because I was shortlisted in a decent number
                of companies. But I have seen people jinki shortlists bhot late aayi thi, and they really had a mental
                pressure. So, I would suggest you guys prepare well. Talking about my interview shortlists, in total, I
                have shortlisted in around 17 firms till day 3. After seeing a decent number of shortlists, I was quite
                confident that I would certainly make it to something good. So I stopped giving more tests and started
                preparing for my interviews.

                <br/><br/>

                For interview preparation, I went through my resume very well (All my projects and internships). My
                resume was mostly ML, optimization, and deep learning. So I had to go through those concepts really
                well, and that took me a lot of time. Along with that, I practiced HR questions in a group of 2-3
                people. We discussed possible questions and their good answers. I also gave one mock interview to one of
                my batchmates. I also revised puzzles and important coding concepts.
            </p>
            <p> <img class="blog-image-right" src="placement-postulates/blogs/Neha-Aggarwal/6.jpg"/>

                Finally, when the day of the interviews arrived, on 30th Nov, I didn't do much. Just prepared me
                mentally for the actual interviews. I couldn't sleep much due to anxiety, but I took a rest and ate
                well. Waking up for the whole night for the interviews gave me headaches, and I survived on disprins and
                caffeine. But all those efforts seem worth it in the end. If you want to know the exact details of the
                interviews which I gave, please reach out to me personally (agar saari details include karungi to bhot
                lamba ho jayega). One more little piece of advice for you guys, please surround yourself with positive
                and helpful people in those stressful times. They will truly make you feel blessed and will guide you
                towards success. If you have put in decent efforts for placements, you will surely end up with a
                brilliant offer.


            </p>
            <p>
                All the best to you all !!

            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Neha_Aggarwal